import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AppAccess {
    accessToken: AccessToken;
}

export interface AccessToken {
    accessToken: string;
    tokenType: string;
    expiresIn: number;
    refreshToken: string;
}

export const initialState: AppAccess = {
    accessToken: {} as AccessToken
};

const appAccessSlice = createSlice({
    name: "appAccess",
    initialState,
    reducers: {
        setAccessToken(state, action: PayloadAction<AccessToken>) {
            state.accessToken = action.payload;
        }
    }
});

export const { setAccessToken } = appAccessSlice.actions;

export default appAccessSlice.reducer;
